import { render, staticRenderFns } from "./ReverseTransaction.vue?vue&type=template&id=3fddd3f0&scoped=true"
import script from "./ReverseTransaction.vue?vue&type=script&lang=js"
export * from "./ReverseTransaction.vue?vue&type=script&lang=js"
import style0 from "./ReverseTransaction.vue?vue&type=style&index=0&id=3fddd3f0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fddd3f0",
  null
  
)

export default component.exports